"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var react_1 = tslib_1.__importDefault(require("react"));
var Input_1 = tslib_1.__importDefault(require("./Input"));
var theme_1 = require("../../utils/theme");
var openEyeUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4zMzMiIGhlaWdodD0iMjEuMzMzIiB2aWV3Qm94PSIwIDAgMTYgMTYiPjxkZWZzPjxjbGlwUGF0aCBpZD0iQSI+PHBhdGggZD0iTTYgNmg0djRINnptMCAwIi8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9IkIiPjxwYXRoIGQ9Ik04IDZjLTEuMTAyIDAtMiAuODk4LTIgMnMuODk4IDIgMiAyIDItLjg5OCAyLTItLjg5OC0yLTItMnptMCAwIi8+PC9jbGlwUGF0aD48L2RlZnM+PHBhdGggZD0iTTggNGMxLjM2IDAgMi44MTYuNjY0IDQuMjIzIDEuOTIyLjYzLjU2MyAxLjE3MiAxLjE4IDEuNjMgMS44NTJMMTQgOGExMC4wNSAxMC4wNSAwIDAgMS0xLjc3NyAyLjA3OEMxMC44MTYgMTEuMzM2IDkuMzYgMTIgOCAxMmMtMS4zMSAwLTIuNzEtLjYxNy00LjA2Ni0xLjc4NWwtLjE1Ni0uMTM3YTEwLjA5IDEwLjA5IDAgMCAxLTEuNjMtMS44NTJMMiA4YTEwLjA1IDEwLjA1IDAgMCAxIDEuNzc3LTIuMDc4QzUuMTggNC42NjQgNi42NCA0IDggNHptMCAwIiBmaWxsPSJub25lIiBzdHJva2U9InJnYig1MC41ODg5ODklLDUyLjU0OTc0NCUsNTYuMDc5MTAyJSkiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PGcgY2xpcC1wYXRoPSJ1cmwoI0EpIj48ZyBjbGlwLXBhdGg9InVybCgjQikiPjxwYXRoIGQ9Ik0zLjUgMy41aDl2OWgtOXptMCAwIiBmaWxsPSJyZ2IoNTAuNTg4OTg5JSw1Mi41NDk3NDQlLDU2LjA3OTEwMiUpIi8+PC9nPjwvZz48L3N2Zz4=";
var closedEyeUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4zMzMiIGhlaWdodD0iMjEuMzMzIiB2aWV3Qm94PSIwIDAgMTYgMTYiPjxkZWZzPjxjbGlwUGF0aCBpZD0iQSI+PHBhdGggZD0iTTEgNWgxNHY4SDF6bTAgMCIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJCIj48cGF0aCBkPSJNMTMuNTMgNS43NzdsMS4zODcgMS40NDVhMTAuMDMgMTAuMDMgMCAwIDEtMS43ODkgMS4zNjNsMS4yMzggMi4xNDUtMS43MzQgMS0xLjMyNC0yLjI5M0E5Ljc3IDkuNzcgMCAwIDEgOSA5Ljk1djIuNTVIN1Y5Ljk1Yy0uNzk3LS4wNzgtMS41Ny0uMjUtMi4zMS0uNTEyTDMuMzY3IDExLjczbC0xLjczNC0xTDIuODcgOC41ODZhOS43MyA5LjczIDAgMCAxLTEuNjItMS4yMTFsLS4xNjgtLjE1MkwyLjQ3IDUuNzc3QTcuOTYgNy45NiAwIDAgMCA4IDhhNy45NiA3Ljk2IDAgMCAwIDUuMzgzLTIuMDgyem0wIDAiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGlwLXBhdGg9InVybCgjQSkiPjxnIGNsaXAtcGF0aD0idXJsKCNCKSI+PHBhdGggZD0iTS0xLjQxOCAzLjI3N2gxOC44MzZWMTVILTEuNDE4em0wIDAiIGZpbGw9InJnYig1MC41ODg5ODklLDUyLjU0OTc0NCUsNTYuMDc5MTAyJSkiLz48L2c+PC9nPjwvc3ZnPg==";
var Password = (function (_super) {
    tslib_1.__extends(Password, _super);
    function Password() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = react_1.default.createRef();
        _this.state = {
            passwordVisible: false
        };
        _this.refDom = function (dom) {
            _this.inputRef.current = dom;
            var propRef = _this.props.inputRef;
            if (!propRef) {
                return;
            }
            if (typeof propRef === 'function') {
                propRef(dom);
            }
            else {
                propRef.current = dom;
            }
        };
        _this.togglePasswordVisibility = function () {
            var dom = _this.inputRef.current;
            var selectionStart = dom.selectionStart, selectionEnd = dom.selectionEnd;
            _this.setState(function (prevState) { return ({ passwordVisible: !prevState.passwordVisible }); }, function () {
                setTimeout(function () {
                    dom.setSelectionRange(selectionStart, selectionEnd);
                }, 0);
            });
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, showToggle = _a.showToggle, rest = tslib_1.__rest(_a, ["showToggle"]);
            var passwordVisible = _this.state.passwordVisible;
            var iconUrl = passwordVisible ? openEyeUrl : closedEyeUrl;
            return (h(Input_1.default, tslib_1.__assign({ icon: showToggle ? iconUrl : undefined, inputStyle: { letterSpacing: passwordVisible ? '2px' : '4px' }, onClickIcon: _this.togglePasswordVisibility, type: passwordVisible ? 'text' : 'password', inputRef: _this.refDom }, rest)));
        };
        return _this;
    }
    Password.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Password;
}(react_1.default.Component));
exports.default = Password;
Password.defaultProps = {
    showToggle: true
};
